import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useEnv } from '../../../context/env-context';
import { useAuth } from '../../../hooks/useAuth';
import { makeRequest } from '../../../utils/makeRequest';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { memo } from 'react';

function FundingActionRow({ fundingId, setSpinner, openRepaymentModal }) {
  const navigate = useNavigate();
  const { apiOriginFunding } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const deletelFunding = async () => {
    if (window.confirm('Are you sure?')) {
      setSpinner(true);
      const token = await getAccessTokenSilently();

      if (!token) {
        return;
      }

      const config = {
        token,
        url: `${apiOriginFunding}/delete`,
        method: 'POST',
        data: JSON.stringify({ fundingId }),
      };

      try {
        await makeRequest(config);

        toast.success('Advance successfully deleted!');
        navigate('/fundings');
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSpinner(false);
      }
    }
  };

  return (
    <Row className="mb-2 mt-5 align-items-center">
      <Col md={12} className="bo-same-line gap-3">
        <Button className="bo-button" onClick={() => deletelFunding()}>
          Delete Advance
        </Button>
        <Button className="bo-button" onClick={() => openRepaymentModal({ topup: false })}>
          Manual Repayment
        </Button>
        <Button className="bo-button" onClick={() => openRepaymentModal({ topup: true })}>
          Manual Top-up
        </Button>
      </Col>
    </Row>
  );
}

export default memo(FundingActionRow);
